import React, { useState } from 'react';

import { debounce } from 'lodash';

import { ChipLoader } from 'components/v2';

import FiltersSelectHeader from '../FiltersSelectHeader';

import FilterGroupData from './FilterGroupData';

interface FilterGroupProps {
  type?: string;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ type = 'group' }) => {
  const [regex, setRegex] = useState<string>('');

  const variables = {
    filter: {
      type: 'user', // Groups created by the user
      ...(regex && { _operators: { name: { regex: `(?i)${regex}` } } }),
    },
  };

  const handleOnSearchChange = (search: string) => setRegex(search);

  return (
    <React.Fragment>
      <FiltersSelectHeader type={type} onSearchChange={debounce(handleOnSearchChange, 600)} />
      <FilterGroupData type={type} variables={variables} />
    </React.Fragment>
  );
};

export default (props: FilterGroupProps) => (
  <React.Suspense fallback={<ChipLoader />}>
    <FilterGroup {...props} />
  </React.Suspense>
);
